/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationLargeGroups200Response
 */
export interface GetReservationLargeGroups200Response {
    /**
     * 
     * @type {number}
     * @memberof GetReservationLargeGroups200Response
     */
    from: number;
}

/**
 * Check if a given object implements the GetReservationLargeGroups200Response interface.
 */
export function instanceOfGetReservationLargeGroups200Response(value: object): value is GetReservationLargeGroups200Response {
    if (!('from' in value) || value['from'] === undefined) return false;
    return true;
}

export function GetReservationLargeGroups200ResponseFromJSON(json: any): GetReservationLargeGroups200Response {
    return GetReservationLargeGroups200ResponseFromJSONTyped(json, false);
}

export function GetReservationLargeGroups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationLargeGroups200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'],
    };
}

export function GetReservationLargeGroups200ResponseToJSON(json: any): GetReservationLargeGroups200Response {
    return GetReservationLargeGroups200ResponseToJSONTyped(json, false);
}

export function GetReservationLargeGroups200ResponseToJSONTyped(value?: GetReservationLargeGroups200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
    };
}

